export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9637.1de768d4.jpg";